import {
  TextField,
  TextFieldProps,
  Typography,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { SxProps, Theme } from "@mui/material/styles";
import { FC, memo } from "react";
import { Control, Controller } from "react-hook-form";

const styles: Record<string, SxProps<Theme>> = {
  formControl: {
    width: "100%",

    "& .MuiTypography-root": {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "20px",
      color: "#25282D",
      marginBottom: "4px",
    },

    "& .MuiFormHelperText-root": {
      marginLeft: 0
    },

    "& .MuiInputBase-multiline": {
      paddingTop: 0,
      paddingLeft: 0,
    },

    "& fieldset": {
      borderColor: "#E0E4EE",
    }
  },
  label: {
    "& span": {
      color: "#FF0000"
    }
  }
};

export interface MuiFormInputProps extends Omit<TextFieldProps<"outlined">, "name" | "variant"> {
  control: Control<any>;
  name: string;
}

const MuiFormInput: FC<MuiFormInputProps> = ({ label, name, control, required, ...props }) => {
  return (
    <FormControl
      sx={styles.formControl}
    >
      {label && (
        <Typography sx={styles.label}>
          {label}
          {required && <span>*</span>}
        </Typography>
      )}
      <Controller
        render={({ field }) => (
          <TextField
            {...props}
            {...field}
            variant="outlined"
          />
        )}
        name={name}
        control={control}
      />
    </FormControl>
  );
};

export default memo(MuiFormInput);
